<app-timeline-transport-edit-row-modal [assignment]='this.currentJobAssignment'></app-timeline-transport-edit-row-modal>
<app-timeline-transport-new-job [job]='this.newJob'></app-timeline-transport-new-job>

<br />
<br />
<button class='btn btn-secondary' (click)='this.onPDFDownload()'><i class="fas fa-file-pdf"></i> Download sheet</button>
<br />
<br />
@if (this.jobAssignments.length === 0) {
  <div class='alert alert-primary' >
    No units available for this date. Please add a unit to start.
  </div>
}
@if (this.jobAssignments.length > 0) {
  <table class='jobAllocationTable'>
    <thead>
      <tr>
        <th>Unit</th>
        <th style='padding-right: 4rem;'>&nbsp;</th>
        <th>Assigned Jobs</th>
        <th>&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      @for (item of this.jobAssignments; track item) {
        <tr>
          <td title='Phone: {{getContact(item)}}'>
            <div class='roundHeader' [class.sub]='item.subcontractorId !== -1'>
              {{ item.name }}
              <div class='mainContent' style='float:left'>
                @if (item.vehicleId !== -1) {
                  <span class="fas fa-fw fa-truck"></span> {{ item.vehicle.registration }} <span class="far fa-fw fa-id-card"></span> {{ item.driver.firstName + ' ' + item.driver.lastName }} ({{ item.driverStartTime }})
                }
                @if (item.subcontractorId !== -1 && item.subcontractorId !== 0) {
                  <span class="far fa-fw fa-id-card"></span> {{ item.subcontractor.name }} ({{ item.driverStartTime }})
                }
                <br/>
                @if (item.upcomingInspection !== undefined) {
                  <span class='text-danger'>Inspection Due: {{item.upcomingInspection}}</span>
                }
              </div>
              <div style='float:right;'>
                <button class='btn btn-primary btn-small' (click)='this.openEditModal(item)'><i class="fas fa-pencil-alt" style='font-size: 0.8rem'></i></button>&nbsp;
                <button class='btn btn-danger btn-small' (click)='this.deleteJobAssignment(item.id)'><i class="fas fa-trash" style='font-size: 0.8rem'></i></button>
              </div>
            </div>
          </td>
          <td>&nbsp;</td>
          <td>
            <div class='allocationContainer'>
              @for (blocki of this.getEmptySlotAsArray(); track blocki) {
                @if (!this.getJobByJobAssignmentIdAndBlockId(item.id, blocki)) {
                  <div class='blockContainer'><input type='checkbox' disabled='disabled' /><div class='timelineBlock' [class.drop]='this.currentHoveredEmptySlot === blocki' [attr.data-id]='blocki' (dragenter)='this.dragEnter($event, item)' (dragleave)='this.dragLeave($event)' (drop)='this.onOrderDrop($event, blocki, item.id)' (dragover)='$event.preventDefault();'></div></div>
                }
                @if (this.getJobByJobAssignmentIdAndBlockId(item.id, blocki)) {
                  <div class='blockContainer'><input type='checkbox' [disabled]='!this.isCheckboxActive(getJobByJobAssignmentIdAndBlockId(item.id, blocki))' [checked]='this.isBoxChecked(this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))' (click)='onSelectedCheckbox($event,this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))' /><div class='timelineBlock allocated' (dragover)='$event.preventDefault();' (drop)='this.onOrderDropOnJob($event, blocki, this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))' [class.drop]='this.curenntHoveredJob === this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).id' (dragenter)='this.dragEnterJob($event, this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))' (dragleave)='this.dragLeaveJob($event, this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'  (dragstart)='this.dragStart($event, this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))' (dragend)='this.dragEnd($event)' draggable='true' [style.background-color]='this.getColorCodeForJob(this.getJobByJobAssignmentIdAndBlockId(item.id, blocki))'><strong>{{ this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).time }} </strong>{{ this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).order.account.name }} - {{ this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).order.site.name }}
                  <div class='qty'>
                    <div class='qtyNo'>{{ this.getJobByJobAssignmentIdAndBlockId(item.id, blocki).qty }}</div>
                  </div>
                </div></div>
              }
            }
          </div>
        </td>
        <td>
          <i class="fas fa-plus-square" (click)='addEmptySlot()'></i>
        </td>
      </tr>
    }
  </tbody>
</table>
}
